var $fe4d3b77866bddd3$exports = {};
$fe4d3b77866bddd3$exports = {
    "pending": `beklemede`
};


export {$fe4d3b77866bddd3$exports as default};
//# sourceMappingURL=tr-TR.mjs.map
